<div>
    <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <input [formControl]="timeCtrl" matInput type="time" />
    </mat-form-field>
</div>
